import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { UPDATE_CUSTOMER_TASK } from "../customer-task.queries";
import { CustomerTaskStatus } from "../../../__generated__/globalTypes";
import {
  UpdateCustomerTaskMutation,
  UpdateCustomerTaskMutationVariables,
} from "../../../__generated__/UpdateCustomerTaskMutation";

export const useSetCustomerTaskStatus = () => {
  const [mutate, { loading }] = useMutation<
    UpdateCustomerTaskMutation,
    UpdateCustomerTaskMutationVariables
  >(UPDATE_CUSTOMER_TASK, {
    refetchQueries: ["CustomerTasksQuery"],
  });

  const setStatus = async (id: number, status: CustomerTaskStatus) => {
    if (loading) return;
    try {
      const { data } = await mutate({ variables: { id, input: { status } } });
      if (!data?.updateCustomerTask?.ok) {
        toast.error(data?.updateCustomerTask?.error ?? "Une erreur est survenue");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return { setStatus, loading };
};
